module.exports = __webpack_public_path__ + "img/usa-ischemic-heart-disease-female.8d775a67.png";